// libraries
import React, { useCallback, useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { useParams } from 'react-router-dom';
// our stuff
import * as constants from 'constants/App';
import Spinner from 'components/Spinner';
import BusyLayout from '../components/BusyLayout';
import PageLayout from '../components/PageLayout';
import Header from '../components/Header';
import CurrentDocumentsStep from './CurrentDocumentsStep';
import UploadStep from './UploadStep';
import BrowseStep from './BrowseStep';
import FormWrapper from 'components/FormWrapper';

const VehicleDocuments = (props) => {
    const params = useParams();
    const vehicleId = props.vehicleId !== undefined ? props.vehicleId : params.vehicleId;
    const [fileForUpload, setFileForUpload] = useState(undefined);

    useEffect(() => {
        props.onLoading(vehicleId);

        return () => {
            props.onUnloading();
        };
    }, [props.onLoading, props.onUnloading, vehicleId]);

    const onDrop = useCallback((acceptedFiles) => {
        if (acceptedFiles && acceptedFiles.length > 0) {
            // Keep file local; Redux state should remain serializable.
            setFileForUpload(acceptedFiles[0]);
        }
    }, []);

    if (props.isBusy) {
        return <BusyLayout><Spinner/></BusyLayout>;
    }

    return <div>
        <PageLayout whiteBackground={false}>
            <div>
                <Header vin8={props.vin8} />

                <FormWrapper key='vehicleDocumentErrorMessage' id="error_message" {...props} formErrors={props.vehicleDocumentErrorMessage || props.errorMessage} />

                <div>
                    {props.step === constants.VEHICLE_DOCUMENT_STEPS.DOCUMENTS ?
                        <CurrentDocumentsStep/>
                        : props.step === constants.VEHICLE_DOCUMENT_STEPS.BROWSE ?
                            <BrowseStep onDrop={onDrop}/>
                            : props.step === constants.VEHICLE_DOCUMENT_STEPS.UPLOAD ?
                                <UploadStep file={fileForUpload}/>
                                : undefined}
                </div>
            </div>
        </PageLayout>
    </div>;
};

const mapStateToProps = (state, props) => {
    return {
        isBusy: state.appState.getIn(['uiData', 'vehicleDocuments', 'isBusy']),
        allowToggleDocumentVisible: state.appState.getIn(['uiData', 'vehicleDocuments', 'allowToggleDocumentVisible']),
        step: state.appState.getIn(['uiData', 'vehicleDocuments', 'step']),
        vin8: (state.appState.getIn(['serverData', 'vehicleDocuments', 'vehicle', 'vin']) || '').slice(-8),
        errorMessage: state.appState.getIn(['uiData', 'shared', 'errorMessage']),
        vehicleDocumentErrorMessage: state.appState.getIn(['uiData', 'vehicleDocuments', 'serverError']),
    };
};

const mapDispatchToProps = (dispatch, props) => {
    return {
        onLoading: (vehicleId) => {
            dispatch({type: constants.VEHICLE_DOCUMENTS_LOADING, vehicleId});

            if (vehicleId !== undefined)
                dispatch({type: constants.FETCH_VEHICLE_DOCUMENTS, vehicleId});
        },
        onUnloading: () => {
            dispatch({type: constants.VEHICLE_DOCUMENTS_UNLOADING});
        },
        onShowDocumentsClick: (vehicleId) => {
            if (vehicleId !== undefined)
                dispatch({type: constants.FETCH_VEHICLE_DOCUMENTS, vehicleId});

            dispatch({type: constants.SHOW_VEHICLE_DOCUMENTS, visible: true});
        },
        onHideDocumentsClick: () => {
            dispatch({type: constants.SHOW_VEHICLE_DOCUMENTS, visible: false});
        },
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(VehicleDocuments);